<script>
import { Sprite, Container } from 'pixi.js'
import SceneMixin from '@/mixins/Scene'

export default {
  name: 'Scene15',
  mixins: [ SceneMixin ],
  beforeDestroy() {
    console.log('beforeDestroy');
    _.each(this.$sprites, (sp, index)=>{
      if(this.$els[index]) this.$els[index]['container'].removeChild(sp)
    })
    this.$container.removeChild(this.$scene)
  },

  created() {

    const sprites = {}
    this.$sprites = sprites
    this.$parent.sprites_scene_15 = sprites

    this.$scene = new Container 
    this.$scene.interactiveChildren = false
    // this.$scene.position.x += 250
    
    this.$container.addChild(this.$scene)
    this.$parent.$scene15 = this.$scene

    const container = new Container()
          container.alpha = 0
    this.setCenterContainer(container)   
    this.$scene.addChild(container)

    const bkg_container = new Container()
    const front_container = new Container()

    container.addChild(bkg_container)
    container.addChild(front_container)

    const sub1 = new TimelineMax()
    const sub2 = new TimelineMax()
    const sub3 = new TimelineMax()
    const sub4 = new TimelineMax()

    // ******************************************************** //
    // ******************************************************** //

    let grad1 = (this.$root.above('tablet')) 
        ? { container: front_container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, y: 1350 }
        : { ref: 'grad1_half', container: front_container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, y: 1350, scale: 1 }

    const els = {
      'bg': { container: bkg_container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }}, 
      'estrades': { container: front_container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }},
      'front': { container: front_container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }},
      'bkg': { container: front_container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }},
      'bancs_left_1': { container: front_container, alpha: 1, position: { x: -581, y: 592, width: 1536, height: 2160 }},
      'bancs_left': { container: front_container, alpha: 1, position: { x: -279, y: 538, width: 1536, height: 2160 }},
      'bancs_right_1': { container: front_container, alpha: 1, position: { x: 579, y: 593, width: 1536, height: 2160 }},
      'bancs_right': { container: front_container, alpha: 1, position: { x: 488, y: 538, width: 1536, height: 2160 }},
      'tables': { container: front_container, alpha: 1, position: { x: 0, y: 520, width: 1536, height: 2160 }},
      'sieges2': { container: front_container, alpha: 1, position: { x: -9, y: 651, width: 1536, height: 2160 }},
      'sieges1': { container: front_container, alpha: 1, position: { x: -8, y: 900, width: 1536, height: 2160 }},
      'full': { container: front_container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }},
      'grey': { container: front_container, alpha: 0, position: { x: 0, y: 0, width: 1536, height: 2160 }},
      'saturate': { container: front_container, alpha: 0, position: { x: 0, y: 0, width: 1536, height: 2160 }},
      'crowd1': { container: front_container, alpha: 1, position: { x: -217, y: 63, width: 1536, height: 2160 }},
      'crowd2': { container: front_container, alpha: 1, position: { x: 330, y: 54, width: 1536, height: 2160 }},
      'crowd3': { container: front_container, alpha: 1, position: { x: 103, y: 0, width: 1536, height: 2160 }},
      'crowd4': { container: front_container, alpha: 1, position: { x: -38, y: -30, width: 1536, height: 2160 }},
      'crowd5': { container: front_container, alpha: 1, position: { x: -42, y: -12, width: 1536, height: 2160 }},
      'crowd6': { container: front_container, alpha: 1, position: { x: 35, y: 36, width: 1536, height: 2160 }},
      'crowd7': { container: front_container, alpha: 1, position: { x: 9, y: -11, width: 1536, height: 2160 }}, 
      'perso': { container: front_container, alpha: 1, position: { x: -371, y: 525, width: 1536, height: 2160 }},
      'perso1': { container: front_container, alpha: 1, position: { x: 691, y: 576, width: 1536, height: 2160 }},
      'perso2': { container: front_container, alpha: 1, position: { x: 377, y: 525, width: 1536, height: 2160 }},
      'perso3': { container: front_container, alpha: 1, position: { x: -440, y: 476, width: 1536, height: 2160 }},
      'perso4': { container: front_container, alpha: 1, position: { x: 444, y: 473, width: 1536, height: 2160 }},
      'perso5': { container: front_container, alpha: 1, position: { x: -677, y: 587, width: 1536, height: 2160 }},
      'perso6': { container: front_container, alpha: 1, position: { x: -556, y: 547, width: 1536, height: 2160 }},
      'perso7': { container: front_container, alpha: 1, position: { x: 532, y: 565, width: 1536, height: 2160 }},
      'perso_center1': { container: front_container, alpha: 1, position: { x: -151, y: 811, width: 1536, height: 2160 }},
      'perso_center11': { container: front_container, alpha: 1, position: { x: 132, y: 819, width: 1536, height: 2160 }},
      'perso_center2': { container: front_container, alpha: 1, position: { x: 66, y: 589, width: 1536, height: 2160 }},
      'perso_center21': { container: front_container, alpha: 1, position: { x: -161, y: 590, width: 1536, height: 2160 }},
      'perso_center3': { container: front_container, alpha: 1, position: { x: -87, y: 514, width: 1536, height: 2160 }},
      'perso_center4': { container: front_container, alpha: 1, position: { x: -141, y: 467, width: 1536, height: 2160 }}, 
      'grad1': grad1,
    }

    _.each(els, (el, name)=>{
      const _name = (el.ref) ? el.ref : name
      const sprite = new Sprite.from(this.$resources[_name].texture) 
            sprite.scale.set(this.$root.$scale)
            sprite.x -= this.$canvas_width/2
            sprite.y -= this.$canvas_height/2
            sprite.alpha = el.alpha
      el.container.addChild(sprite)
      sprites[name] = sprite
      this.applySettings(sprite, el)
    })

    this.$els = els

    // ******************************************************** //
    // ******************************************************** //

    // const alphaFilter = new PIXI.filters.AlphaFilter(0.0)
    // container.filters = [ alphaFilter ]

    const appear = 22
    const buddys = [sprites['perso_center1'], sprites['perso_center3'], sprites['perso_center11'], sprites['perso_center2'], sprites['perso'], sprites['perso_center21'], sprites['perso1'], sprites['perso2'], sprites['perso3'], sprites['perso4'], sprites['perso5'], sprites['perso6'], sprites['perso7']]
    const crowd = [sprites['crowd1'], sprites['crowd2'], sprites['crowd3'], sprites['crowd4'], sprites['crowd5'], sprites['crowd6'], sprites['crowd7']]
    const elements_to_top = _.concat(sprites['saturate'], buddys, crowd, sprites['perso_center4'])

    sub1
      .add([
        TweenMax.to(container, .5, { alpha: 1, ease: Linear.easeNone }),
        TweenMax.from(sprites['front'], appear*.1, { pixi: { alpha: 0 } }),
        TweenMax.from(sprites['estrades'], appear*.1, { pixi: { alpha: 0, y: '+=10' }, delay: appear*.05 }),
      ])
      .from(sprites['bkg'], appear*0.10, { pixi:{ alpha: 0 }, ease: Linear.easeNone })
      .add([
       
        TweenMax.staggerFrom([ sprites['bancs_left'], sprites['bancs_left_1'] ], appear*0.02, { pixi:{ alpha: 0 }, ease: Linear.easeNone }, appear*.01),
        TweenMax.staggerFrom([ sprites['bancs_left'], sprites['bancs_left_1'] ], appear*0.10, { pixi:{ x: '-=50' }, ease: Cubic.easeOut }, appear*.01),  
        TweenMax.staggerFrom([ sprites['bancs_right'], sprites['bancs_right_1'] ], appear*0.02, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*.01 }, appear*.01),
        TweenMax.staggerFrom([ sprites['bancs_right'], sprites['bancs_right_1'] ], appear*0.10, { pixi:{ x: '+=50' }, ease: Cubic.easeOut, delay: appear*.01 }, appear*.01),   

        TweenMax.from(sprites['tables'], appear*0.02, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.20 }),
        TweenMax.from(sprites['tables'], appear*0.10, { pixi:{  y: '+=25' }, ease: Cubic.easeOut, delay: appear*0.20 }),
        TweenMax.from(sprites['sieges2'], appear*0.02, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.15 }),
        TweenMax.from(sprites['sieges2'], appear*0.10, { pixi:{  y: '+=25' }, ease: Cubic.easeOut, delay: appear*0.15 }),
        TweenMax.from(sprites['sieges1'], appear*0.02, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.075 }),
        TweenMax.from(sprites['sieges1'], appear*0.10, { pixi:{  y: '+=25' }, ease: Cubic.easeOut, delay: appear*0.075 }),
        TweenMax.from(sprites['full'], appear*0.10, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.30 }),
        
        TweenMax.staggerFrom(buddys, appear*0.05, 
        { 
            pixi: { alpha: 0 }, 
            ease: Linear.easeNone, 
            delay: appear*0.20,  
            overwrite: false 
          }, 
          appear*0.03),

        TweenMax.staggerFrom(crowd, appear*0.12, { pixi:{  alpha: 0 }, ease: Linear.easeNone, delay: appear*0.25 }, appear*0.02),

        TweenMax.from(sprites['perso_center4'], appear*0.10, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.7 }),
        TweenMax.to(container, appear*0.50, { pixi:{ scale: this.$root.$scale*4, y: '-=400' }, ease: Linear.easeNone, delay: appear*0.6 }),
      ])

    sub2
      .add([

        // TweenMax.to(container, 2, { pixi:{ y: '+=50' }, ease: Linear.easeNone }),
        // TweenMax.to(container, 20, { pixi:{ y: '+=320' }, ease: Linear.easeNone, delay: 2 }),
        // TweenMax.to(container, 22, { pixi:{ scale: '-=.84' }, ease: Cubic.easeIn }),

        TweenMax.to(container, 2, { pixi:{ y: '+=50' }, ease: Linear.easeNone }),
        TweenMax.to(container, 20, { pixi:{ y: '+=220' }, ease: Linear.easeNone, delay: 2 }),
        TweenMax.to(container, 22, { pixi:{ scale: '-=.66' }, ease: Cubic.easeIn }),

      ])

    sub3
      .to(container, 0.1, { pixi:{ scale: '-=0' }, ease: Cubic.easeIn })
      .to(sprites['grad1'], 2, { pixi:{ y: -270 }, ease: Linear.easeNone })

    sub4
      .add([
        ()=>{
          _.each(buddys, (b)=> {
            TweenMax.to(b, .5, { pixi:{ alpha: 1 }, ease: Linear.easeNone })
          })
        },

      ])

    this.$tl.add(sub1, 61)
    this.$tl.add(sub2, 87)
    this.$tl.add(sub4, 90)
    this.$tl.add(sub3, 109)

    // -280
    
  },
  mounted() {

    // console.log('Scene15');
    // this.$parent.chapter.$tl.seek(53)
    
  }
}
</script>























